import checkout from "./form";

const {
  formField: {
    nameOfProductionBusinessActivities,
    taxCalculationPeriod,
    firstTime,
    supplementaryForThe,
    taxpayerName,
    taxId,
    projectName,
    addressActive,
    addressWard,
    addressDistrict,
    addressCity,
    contract,
    projectDay,
    projectOf,
    taxAgentName,
    taxAgentId,
    taxAgencyName,
    taxAgencyId,
    contractNumber,
    contractDay,
    fullName,
    signer,
    timeSign,
  },
} = checkout;

const initialValues = {
  [taxAgentName.name]: "",
  [fullName.name]: "",
  [firstTime.name]: false,
  [signer.name]: "",
  [supplementaryForThe.name]: "",
  [taxAgencyId.name]: "",
  [taxAgencyName.name]: "",
  [taxCalculationPeriod.name]: "",
  [taxId.name]: "",
  [taxpayerName.name]: "",
  [timeSign.name]: "",
  [nameOfProductionBusinessActivities.name]: "",
  [contractNumber.name]: "",
  [contractDay.name]: "",
  [addressWard.name]: "",
  [addressDistrict.name]: "",
  [addressCity.name]: "",
  [projectName.name]: "",
  [addressActive.name]: "",
  [contract.name]: "",
  [projectDay.name]: "",
  [projectOf.name]: "",
  [taxAgentId.name]: "",
};

export default initialValues;
